module.exports = __webpack_public_path__ + "static/media/combat(24).6277ea0d.PNG";